export default "__VITE_ASSET__CdKvlIUr__"